/**
 * Error codes for the CDN Client.
 */
export var CdnClientErrorCode;
(function (CdnClientErrorCode) {
    /**
     * UnknownError
     */
    CdnClientErrorCode[CdnClientErrorCode["UnknownError"] = 21000] = "UnknownError";
    /**
     * Configuration was not provided for the Vista CDN provider.
     */
    CdnClientErrorCode[CdnClientErrorCode["VistaProviderNotConfigured"] = 21001] = "VistaProviderNotConfigured";
})(CdnClientErrorCode || (CdnClientErrorCode = {}));
//# sourceMappingURL=cdn-client-error-code.js.map